module.exports = __webpack_public_path__ + "img/btn-swiper-play-control-02-m.014bffb9.svg";